<template>
  <div class="mt-3 mb-3 row row-cols-lg-12 principal-stepper">
    <ul class="progressbar">
      <li
        :key="index"
        v-for="(paso, index) in pasos"
        :class="paso.completado ? 'active' : ''"
      >
        <label :class="paso.completado ? 'label-paso-a' : 'label-paso'">
          {{ paso.nombre }}
        </label>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "StepperIntegracion",
  props: {
    pasos: Array,
    pasoActual: Number
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
$color-primario: #b8725a;
$poppins: "Poppins";
$gris-deshabilitado: #bcbcbc;

.progressbar {
  counter-reset: step;
}
.progressbar li {
  list-style-type: none;
  width: 32%;
  font-size: 15px;
  position: relative;
  text-align: center;
  text-transform: capitalize;
  font-family: $poppins;
  font-weight: 700;
  color: #696158;
  float: left;
}

.label-paso {
  color: rgba(105, 97, 88, 100%);
  opacity: 0.5;
}
.label-paso-a {
  color: rgba(105, 97, 88, 100%);
}

.progressbar li:before {
  width: 18px;
  height: 18px;
  counter-increment: step;
  border: 2px solid #ada8a3;
  background: white;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 22px;
  color: #ffffff;
  text-align: center;
  content: "";
}
.progressbar li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  background: $gris-deshabilitado;
  top: 9px;
  left: -50%;
  z-index: -1;
}
.progressbar li.active:before {
  content: "\f00c" !important;
  font-weight: 900;
  font-size: 13px;
  font-family: "Font Awesome 5 Free";
  width: 24px;
  height: 24px;
  border: 2px solid #28893b !important;
  background-color: #28893b !important;
  color: white;
}
.progressbar li.active:after {
  background: $gris-deshabilitado;
}
.progressbar li.active ~ li:after {
  background: $gris-deshabilitado;
}
.progressbar li.active ~ li:before {
  border-color: $gris-deshabilitado;
  background: white;
  color: white;
}
.progressbar li:first-child:after {
  content: none;
}

@media all and (max-width: 767px) {
  .principal-stepper {
    display: none;
  }
}
</style>
